var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"chart-main-container"},[_c('chart',{ref:"chart",attrs:{"chartType":"line","chartId":"TrendChart","width":_vm.size === 'mini' ? 300 : 836,"height":_vm.size === 'mini' ? 180 : 400}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c03cb5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chart/trend.vue
// module id = null
// module chunks = 